import { SelectMarkerIcon } from './SelectMarkerIcon';

/**
 * author: Austin Andrews
 * id A312AB96-5A12-4223-AF67-7067653E17E5
 * name select-marker
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/select-marker.svg
 * tags
 * - Navigation 
 */
export const SelectLocationIcon = SelectMarkerIcon;
export default SelectLocationIcon